import UIFetchService from '../Service/UIFetchService';
import { toThousands } from '../Service/Utils'

import React from 'react';
import { Layout, Input, Card, Tree, Table, Space, Row, Col } from 'antd';
import { DownOutlined } from '@ant-design/icons';

class BasicTagsView extends React.Component {

    constructor() {
        super();
        this.state = {
            tag: {
                date: '????-??-??',
                tagName: '',
                groupTotal: NaN,
                tagTaotal: NaN,
                items: []
            },
            tagsTree: {
                selectedKeys: [],
                expandedKeys: []
            }
        };
    }

    async componentDidMount() {
        const tags = await UIFetchService.get('/api/v1/user_profile/tags')
        this.setState({ tags: tags, selectedKeys: ['1'], expandedKeys: ['集团基础属性'] });
        this.tagsTreeDidSelected("2");
    }

    render() {
        return (
            <div hidden={this.props.hidden}>
                <Layout className="site-layout-background" style={{ padding: '24px 0' }}>
                    <Layout.Sider className="site-layout-background" width={300} theme={"light"}>
                        <Row>
                            <Input.Search
                                allowClear
                                onChange={this.tagsTreeDidChanged} />
                        </Row>
                        <div style={{ height: '40px' }}></div>
                        <Row>
                            <Card>
                                <Tree
                                    showIcon
                                    switcherIcon={<DownOutlined />}
                                    defaultExpandParent
                                    onExpand={this.tagsTreeDidExpand}
                                    onSelect={this.tagsTreeDidSelected}
                                    expandedKeys={this.state.tagsTree.expandedKeys}
                                    selectedKeys={this.state.tagsTree.selectedKeys}
                                    treeData={this.state.tags}
                                    defaultExpandedKeys={this.state.tagsTree.expandedKeys}
                                />
                            </Card>
                        </Row>
                    </Layout.Sider>
                    <Layout.Content style={{ padding: '0px 0px 0px 40px' }}>
                        <Row>
                            <span className="site-span-tags-title" >标签分布：{this.state.tag.tagName}</span>
                        </Row>
                        <div style={{ height: '10px' }} />
                        <Row>
                            <Col flex="auto" style={{ textAlign: 'left' }}>
                                <Space>
                                    <span className="site-span-tags-desc">有该标签人数</span>
                                    <sapn className="site-span-tags-statistics">{isNaN(this.state.tag.tagTotal) ? '--' : toThousands(this.state.tag.tagTotal)}</sapn>
                                    <sapn className="site-span-tags-desc">覆盖集团整体用户</sapn>
                                    <sapn className="site-span-tags-statistics">{isNaN(this.state.tag.groupTotal) ? '--' : toThousands(this.state.tag.groupTotal)}</sapn>
                                    <sapn className="site-span-tags-desc">的</sapn>
                                    <sapn className="site-span-tags-statistics">{
                                        isNaN(this.state.tag.tagTotal) || isNaN(this.state.tag.groupTotal)
                                            ? '--'
                                            : ((this.state.tag.tagTotal / this.state.tag.groupTotal) * 100).toFixed(2)
                                    }</sapn>
                                    <sapn className="site-span-tags-desc">%</sapn>
                                </Space>
                            </Col>
                            <Col flex="200px">
                                <span>标签更新日期：{this.state.tag.date}</span>
                            </Col>
                        </Row>
                        <div style={{ height: '10px' }} />
                        <Row>
                            <Col flex="100%">
                                <Table dataSource={this.state.tag.items}>
                                    <Table.Column
                                        title="标签值"
                                        dataIndex="key"
                                        key="key"
                                        render={(_, record) =>
                                            <sapn>
                                                {record.key === null ? '未知' : (record.key === '<others>' ? '其他' : record.key)}
                                            </sapn>
                                        } />
                                    <Table.Column
                                        title="人数"
                                        dataIndex="value"
                                        key="value"
                                        render={(_, record) =>
                                            <span>{toThousands(record.value)}</span>
                                        } />
                                    <Table.Column
                                        title="占比"
                                        dataIndex="rate"
                                        key="rate"
                                        render={(_, record) =>
                                            <>
                                                {(record.key === null)
                                                    ? <sapn>--</sapn>
                                                    : <span>{((record.value / this.state.tag.tagTotal) * 100).toFixed(2)}</span>}
                                                <sapn>%</sapn>
                                            </>
                                        } />
                                    <Table.Column
                                        title="覆盖率(集团整体用户的覆盖率)"
                                        dataIndex="coverage"
                                        key="coverage"
                                        render={(_, record) =>
                                            <>
                                                <span>{((record.value / this.state.tag.groupTotal) * 100).toFixed(2)}</span>
                                                <sapn>%</sapn>
                                            </>
                                        } />
                                </Table>
                            </Col>
                        </Row>
                    </Layout.Content>
                </Layout>
            </div>
        )
    }


    tagsTreeDidChanged = async (event) => {
        const searchKey = event.target.value;
        const tags = await UIFetchService.get('/api/v1/user_profile/tags?searchKey=' + encodeURI(searchKey));
        this.setState({ tags: tags });
    }

    tagsTreeDidSelected = async (keys) => {
        const state = this.state.tagsTree;
        state.selectedKeys = keys;
        this.setState({ tagsTree: state });

        const id = this.hasTagSelected(keys);
        if (id > 0) {
            const tag = await UIFetchService.get('/api/v1/user_profile/tags/' + id + '/statistics?date=2020-11-24');
            this.setState({ tag: tag });
        }
    }

    tagsTreeDidExpand = (keys) => {
        const state = this.state.tagsTree;
        state.expandedKeys = keys;
        this.setState({ tagsTree: state });
    }

    hasTagSelected(keys) {
        if (keys.length <= 0) {
            return 0;
        }
        const key = keys[0];
        const tid = parseInt(key);
        return isNaN(tid) ? 0 : tid;
    }
}

export default BasicTagsView;